<template>
  <v-flex class="tables-layout">
    <table-layout>
      <template v-slot:title>
        팀별 실적 (전체)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalTeamHeader)"
          :items="amtList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        팀별 실적 (집단대출/비율)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalTeamHeader)"
          :items="groupAmtList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        팀별 실적 (일반대출/비율)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalTeamHeader)"
          :items="generalAmtList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        팀별 실적 (이주비 중도금/비율)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalTeamHeader)"
          :items="relocationAmtList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        상품별 실적 (전체)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalProductHeader)"
          :items="productList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <v-row>
      <v-col>
        <table-layout>
          <template v-slot:title>
            관리팀장 실적 (전체)
          </template>
          <template v-slot:table>
            <v-data-table
                class="data-table-layout"
                height="30vh" fixed-header
                :headers="getHeader(totalManagerHeader)"
                :items="adminManagerList"
                no-data-text="조회된 데이터가 없습니다"
                :items-per-page="-1"
                hide-default-footer
                mobile-breakpoint="md"
            >
              <template v-slot:item.cnt="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.loanAmount="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
            </v-data-table>
          </template>
        </table-layout>
      </v-col>
      <v-col>
        <table-layout>
          <template v-slot:title>
            영업팀장 실적 (전체)
          </template>
          <template v-slot:table>
            <v-data-table
                class="data-table-layout"
                height="30vh" fixed-header
                :headers="getHeader(totalManagerHeader)"
                :items="salesManagerList"
                no-data-text="조회된 데이터가 없습니다"
                :items-per-page="-1"
                hide-default-footer
                mobile-breakpoint="md"
            >
              <template v-slot:item.cnt="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.loanAmount="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
            </v-data-table>
          </template>
        </table-layout>
      </v-col>
    </v-row>
    <table-layout>
      <template v-slot:title>
        대출유형별 실적 (전체)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalLoanTypeHeader)"
          :items="loanTypeList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <table-layout>
      <template v-slot:title>
        대출유형별 실적 (주담대)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          height="30vh" fixed-header
          :headers="getHeader(totalLoanTypeHeader)"
          :items="loanTypeGroupList"
          no-data-text="조회된 데이터가 없습니다"
          :items-per-page="-1"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
  </v-flex>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {
  LOAN_PERFORMANCE_TOTAL_LOAN_TYPE_TABLE,
  LOAN_PERFORMANCE_TOTAL_MANAGER_TABLE,
  LOAN_PERFORMANCE_TOTAL_PRODUCT_TABLE,
  LOAN_PERFORMANCE_TOTAL_TEAM_TABLE
} from "@/util/TableHeaders";
import _ from "lodash";

export default {
  name: "LoanPerformanceTotalDetail",
  components: {TableLayout},
  props: ["data", "loading"],
  mixins: [TableMixin],
  data() {
    return {
      totalTeamHeader: LOAN_PERFORMANCE_TOTAL_TEAM_TABLE,
      totalProductHeader: LOAN_PERFORMANCE_TOTAL_PRODUCT_TABLE,
      totalManagerHeader: LOAN_PERFORMANCE_TOTAL_MANAGER_TABLE,
      totalLoanTypeHeader: LOAN_PERFORMANCE_TOTAL_LOAN_TYPE_TABLE,
      amtList: [],
      groupAmtList: [],
      generalAmtList: [],
      relocationAmtList: [],
      productList: [],
      loanTypeList: [],
      loanTypeGroupList: [],
      salesManagerList: [],
      adminManagerList: []
    }
  },
  watch: {
    data(value) {
      if (!_.isEmpty(value)) {
        this.amtList = value.performanceAllSumByAmtList;
        this.groupAmtList = value.performanceAllSumByGroupAmtList;
        this.generalAmtList = value.performanceAllSumByGeneralAmtList;
        this.relocationAmtList = value.performanceAllSumByRelocationAmtList;
        this.productList = value.performanceAllSumByProductList;
        this.loanTypeList = value.performanceAllSumByLoanTypeList;
        this.loanTypeGroupList = value.performanceAllSumByLoanTypeGroupList;
        this.salesManagerList = value.performanceAllSumBySalesManagerList;
        this.adminManagerList = value.performanceAllSumByAdminManagerList;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tables-layout {
  height: 65vh;
  max-height: 800px;
  overflow-y: auto;
  .data-table-layout {
    padding: 20px 10px;
    border: 1px solid #222;
  }
}
</style>